import React from 'react';
import { IconProps } from '../IconProps';
const SvgNovaBadge = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" {...props}>
    <rect width={18} height={18} rx={9} fill={primaryColor} />
    <path
      d="M10.443 4.773V13.5H8.862V6.311H8.81L6.77 7.615V6.166l2.168-1.393h1.505z"
      fill="#fff"
    />
  </svg>
);
export default SvgNovaBadge;
